import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Router, RouterModule } from '@angular/router';
import { LoadComponent } from 'src/app/ui-design-library/load/load.component';
import { AsyncPipe } from '@angular/common';
import { Template } from '../template.model';
import { TemplateService } from '../template.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'fnsr-template-list',
  standalone: true,
  imports: [LoadComponent, AsyncPipe, RouterModule, FormsModule],
  templateUrl: './template-list.component.html',
  styles: `
  fnsr-medium-card {
    cursor: pointer;
    transition: transform 0.2s ease;
  }

  fnsr-medium-card:hover {
    transform: translate(0, -3px);
  }
  `
})
export class TemplateListComponent implements OnInit {
  templates$: Observable<Template[]>;
  originalTemplates: Template[] = [];
  filteredTemplates: Template[] = [];
  sortDirection: { [key: string]: boolean } = {};

  searchText: string = '';
  selectedCategory: string = '';
  uniqueCategories: string[] = [];

  showFilterAndSearch: boolean = false;

  constructor(
    public templateService: TemplateService,
    public router: Router
  ) {
    this.templates$ = this.templateService.getTemplates();
  }

  ngOnInit(): void {
    this.templates$.subscribe(templates => {
      this.originalTemplates = [...templates];
      this.filteredTemplates = [...templates];

      this.uniqueCategories = [...new Set(templates.map(t => t.category))].sort();
    });
  }

  sortTemplates(key: keyof Template): void {
    console.log('sortTemplates', key);
    this.sortDirection[key] = !this.sortDirection[key]; // Sortierreihenfolge umkehren
    const direction = this.sortDirection[key] ? 1 : -1;

    this.filteredTemplates.sort((a, b) => {
      const aValue = a[key] ?? '';
      const bValue = b[key] ?? '';
      if (aValue < bValue) {
        return -1 * direction;
      } else if (aValue > bValue) {
        return 1 * direction;
      } else {
        return 0;
      }
    });
  }

  toggleFilters(event: Event): void {
    event.preventDefault(); // Verhindert, dass die Seite scrollt oder neu lädt
    this.showFilterAndSearch = !this.showFilterAndSearch;
  }

  filterTemplates(): void {
    this.filteredTemplates = this.originalTemplates.filter(template => {
      const matchesCategory = this.selectedCategory ? template.category === this.selectedCategory : true;
      const matchesSearch = this.searchText ? template.name.toLowerCase().includes(this.searchText.toLowerCase()) : true;
      return matchesCategory && matchesSearch;
    });
  }
  
  resetFilters(): void {
    this.searchText = '';
    this.selectedCategory = '';
    this.filteredTemplates = [...this.originalTemplates];
  }
}